export default {
  UPDATE_ITEMS: "@commons/UPDATE_ITEMS"
};
